var i18n = require('i18n');
var pop = require('fe-pop');
var ajax = require('fe-util-ajax');

var util = {};

util.makeZero = function(num) {
  return num < 10 ? '0' + num : num;
}

util.format = function(time) {
  var date = new Date(time);
  return date.getFullYear() + '-' + util.makeZero(date.getMonth() + 1) + '-' + util.makeZero(date.getDate()) +
    ' ' + util.makeZero(date.getHours()) + ':' + util.makeZero(date.getMinutes()) + ':' + util.makeZero(date.getSeconds());
}

util.getCookie = function(name) {
  var i, cookie, cookieStr,
    cookies = document.cookie.split(";");

  for (i = 0; i < cookies.length; i++) {
    cookie = cookies[i];
    cookieStr = cookie.split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
      return decodeURI(cookieStr[1]);
    }
  }
}

util.setCookie = function(name, value, expire, domain, path, secure) {
  var date,
    str = escape(name) + "=" + escape(value);
  date = new Date();

  date.setTime(date.getTime() + expire);
  str += domain ? "; domain=" + domain : "";
  str += path ? "; path=" + path : "";
  str += expire ? "; expires=" + date.toGMTString() : "";
  str += secure ? "; secure" : "";
  document.cookie = str;
}

util.loadData = (function() {
  var loading = {};
  return function(url, data, type, success, fail) {
    if (typeof type == 'function') {
      fail = success;
      success = type;
      type = 'GET';
    }

    if (loading[url]) {
      return;
    }
    //end loading
    for (var i in loading) {
      delete loading[i];
    }
    loading[url] = 1;

    //start loading
    ajax({
      type: type,
      url: url,
      data: data
    }, function(res) {
      if (loading[url]) {
        delete loading[url]
        if (typeof res != 'object') {
          util.show({
            icon: 'warning',
            content: 'not login'
          });
          return;
        }
        if (res.success) {
          success(res);
        } else {
          util.show({
            icon: 'error',
            content: res.message
          });
        }
      }
      //end loading
    }, function() {
      //end loading
      delete loading[url];
    })
  }
})();


util.showConfirm = (function() {
  var html = '<div class="ui small modal transition hidden dialog-util">\
    <div class="header">' + i18n('common.tip') + '</div>\
    <div class="content"><p></p></div>\
    <div class="actions">\
      <div class="ui button">' + i18n('common.cancel') + '</div>\
      <div class="ui right  button">' + i18n('common.confirm') + '</div>\
    </div>\
  </div>';

  var node = $(html);
  $('body').append(node);
  return function(msg, confirm, deny) {
    node.find('.content p').text(msg);
    node.modal({
      closable: false
    }).modal('show');
    node.find('.actions .button').eq(0).off('click').click(function() {
      node.modal('hide');
      deny && deny()
    }).end().eq(1).off('click').click(function() {
      node.modal('hide');
      confirm && confirm()
    })
  }
})();


util.show = function(opt) {
  pop.show(opt)
}
util.hide = function() {
  pop.hide()
}

module.exports = util;


// WEBPACK FOOTER //
// ./src/app/util.js